exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#render-container .mbgf-column-row{width:calc(100% + 30px)}.mbgf-column-row{display:-ms-flexbox;display:flex;width:calc(100% + 30px);margin-left:-15px;margin-right:-15px}.mbgf-column-row .mbgf-column-box{display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;-ms-flex:1;flex:1}@media (max-width:767px){.mbgf-column-row{-ms-flex-direction:column;flex-direction:column}.mbgf-column-row .mbgf-column-box{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/column/column.styl
// module id = 13
// module chunks = 0 1